// src/pages/Schedule.js
import React from "react";
import "../App.css";
import "../Navbar.css";
import PottsboroLogo from "../images/Logo.jpg";

/** ============================
 *  EXPORT the schedule array
 *  (so Home.js can import it)
 *  ============================ */
export const schedule = [
  
  { date: "Dec 2", opponent: "Tom Bean", site: "Pottsboro High School", varsity: "6:15", jv: "5:00", home: true },
  { date: "Dec 4-6", opponent: "Decatur JV Tournament", site: "Decatur High School", varsity: "-", jv: "TBD", jv2: "-", home: false, bracket: "/tournaments/decatur_jv.pdf" },
  { date: "Dec 5-6", opponent: "Dodd City Varsity Tournament", site: "Dodd City High School", varsity: "TBD", jv: "-", jv2: "-", home: false, bracket: "/tournaments/doddcity_varsity.pdf" },
  { date: "Dec 9", opponent: "Denton Braswell", site: "Denton Braswell High School", varsity: "-", jv: "6:15", jv2: "-", home: false },
  { date: "Dec 11-13", opponent: "Glen Rose Varsity Tournament", site: "Glen Rose High School", varsity: "TBD", jv: "-", jv2: "-", home: false, bracket: "/tournaments/glenrose_varsity.pdf" },
  { date: "Dec 19", opponent: "Howe", site: "Pottsboro High School", varsity: "7:30", jv: "5:45", jv2: "4:30", home: true },
  { date: "Dec 22", opponent: "Commerce", site: "Commerce High School", varsity: "1:00", jv: "12:00", jv2: "11:00", home: false },
  { date: "Dec 29-30", opponent: "Van Alstyne JV Tournament", site: "Van Alstyne High School", varsity: "-", jv: "TBD", jv2: "-", home: false, bracket: "/tournaments/vanalstyne_jv.pdf" },
  { date: "Dec 29-31", opponent: "NCTC Varsity Tournament", site: "NCTC / Lindsay", varsity: "TBD", jv: "-", jv2: "-", home: false, bracket: "/tournaments/nctc_varsity.pdf" },
  { date: "Jan 6", opponent: "S&S", site: "S&S High School", varsity: "7:30", jv: "5:45", jv2: "4:30", home: false },
  { date: "Jan 9", opponent: "Bells", site: "Pottsboro High School", varsity: "7:30", jv: "5:45", jv2: "4:30", home: true },
  { date: "Jan 13", opponent: "Blue Ridge", site: "Blue Ridge High School", varsity: "7:30", jv: "5:45", jv2: "4:30", home: false },
  { date: "Jan 16", opponent: "Leonard", site: "Pottsboro High School", varsity: "7:30", jv: "5:45", jv2: "4:30", home: true },
  { date: "Jan 23", opponent: "Gunter", site: "Pottsboro High School", varsity: "7:30", jv: "5:45", jv2: "4:30", home: true },
  { date: "Jan 27", opponent: "Howe", site: "Howe High School", varsity: "7:30", jv: "5:00", jv2: "4:00", home: false },
  { date: "Jan 30", opponent: "S&S", site: "Pottsboro High School", varsity: "7:30", jv: "5:00", jv2: "4:00", home: true },
  { date: "Feb 3", opponent: "Bells", site: "Bells High School", varsity: "7:30", jv: "5:00", jv2: "4:00", home: false },
  { date: "Feb 6", opponent: "Blue Ridge", site: "Pottsboro High School", varsity: "7:30", jv: "5:00", jv2: "4:00", home: true },
  { date: "Feb 10", opponent: "Leonard", site: "Leonard High School", varsity: "7:30", jv: "5:00", jv2: "5:00", home: false },
  { date: "Feb 17", opponent: "Gunter", site: "Gunter High School", varsity: "7:30", jv: "5:00", jv2: "5:00", home: false },
  { date: "Feb 23 or 24", opponent: "Bi-District Playoff", site: "TBD", varsity: "TBD", jv: "-", jv2: "-", home: false },
  { date: "Feb 26 or 27", opponent: "Area Playoff", site: "TBD", varsity: "TBD", jv: "-", jv2: "-", home: false },
  { date: "Mar 2 or 3", opponent: "Regional Semifinals", site: "TBD", varsity: "TBD", jv: "-", jv2: "-", home: false },
  { date: "Mar 5 or 6", opponent: "Regional Finals", site: "TBD", varsity: "TBD", jv: "-", jv2: "-", home: false },
  { date: "Mar 9 or 10", opponent: "State Semifinals", site: "TBD", varsity: "TBD", jv: "-", jv2: "-", home: false },
  { date: "Mar 13", opponent: "State Championship", site: "Alamodome, San Antonio", varsity: "TBD", jv: "-", jv2: "-", home: false },
  { date: "Nov 14", opponent: "Slidell", site: "Pottsboro High School", varsity: "Pottsboro 62 Slidell 70", jv: "Pottsboro 31 Slidell 33", jv2: "-", home: true },
  { date: "Nov 18", opponent: "Callisburg", site: "Pottsboro High School", varsity: "Pottsboro Callsiburg ", jv: "-", home: true },
  { date: "Nov 20", opponent: "Prosper Richland", site: "Prosper Richland High School", varsity: "Pottsboro Richland ", jv: "Pottsboro Richland", home: false },
  { date: "Nov 24", opponent: "Van Alstyne", site: "Pottsboro High School", varsity: "Pottsboro 55 Van Alstyne 59", jv: "Pottsboro Van Alstyne", home: true },
  { date: "Nov 25", opponent: "Ponder", site: "Pottsboro High School", varsity: "Pottsboro  Ponder ", jv: "Pottsboro  Ponder", home: true },
];

/** Helpers */
const getMapLink = (location) =>
  `https://www.google.com/maps/search/${encodeURIComponent(location)}`;

const getCalendarLink = (game) => {
  const title = `Pottsboro vs ${game.opponent}`;
  const details = `Varsity: ${game.varsity} | JV: ${game.jv} | JV2: ${game.jv2}`;
  return `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
    title
  )}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(game.site)}`;
};

/** ============================
 *  DEFAULT PAGE EXPORT
 *  ============================ */
export default function Schedule() {
  return (
    <div className="page schedule-page" style={{ backgroundColor: "#fff", color: "#000" }}>
      <h1
        className="page-title"
        style={{
          textAlign: "center",
          marginBottom: "20px",
          color: "#a60000",
          textTransform: "uppercase",
          fontWeight: "900",
          letterSpacing: "1px",
        }}
      >
        2025–2026 High School Basketball Schedule
      </h1>

      <div className="schedule-list">
        {schedule.map((game, index) => (
          <div
            key={index}
            className={`game-card ${game.home ? "home-game" : "away-game"}`}
            style={{
              backgroundColor: "#f9f9f9",
              color: "#000",
              borderRadius: "12px",
              padding: "1rem",
              marginBottom: "1rem",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            }}
          >
            <div
              className="game-header"
              style={{ display: "flex", alignItems: "center", marginBottom: "0.6rem" }}
            >
              <img
                src={PottsboroLogo}
                alt="Team logo"
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  marginRight: "10px",
                  border: "2px solid #a60000",
                  objectFit: "cover",
                }}
              />
              <div>
                <h3 style={{ margin: "0", color: "#a60000" }}>{game.date}</h3>
                <h2 style={{ margin: "2px 0", fontSize: "1.2rem" }}>{game.opponent}</h2>
              </div>
            </div>

            <p><strong>Site:</strong> {game.site}</p>
            <p><strong>Varsity:</strong> {game.varsity}</p>
            <p><strong>JV:</strong> {game.jv}</p>
            <p><strong>JV2:</strong> {game.jv2}</p>

            <div
              className="button-row"
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              {/* 🗺️ Directions Button */}
              <a
                href={getMapLink(game.site)}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#a60000",
                  color: "#fff",
                  padding: "0.5rem 0.9rem",
                  borderRadius: "6px",
                  textDecoration: "none",
                  fontWeight: "700",
                  flex: "1",
                  textAlign: "center",
                }}
              >
                🗺️ Directions
              </a>

              {/* 📅 Add to Calendar */}
              <a
                href={getCalendarLink(game)}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#222",
                  color: "#fff",
                  padding: "0.5rem 0.9rem",
                  borderRadius: "6px",
                  textDecoration: "none",
                  fontWeight: "700",
                  flex: "1",
                  textAlign: "center",
                }}
              >
                📅 Add to Calendar
              </a>

              {/* 🏆 View Bracket (for tournament games only) */}
              {game.bracket && (
                <a
                  href={game.bracket}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#b30000",
                    color: "#fff",
                    padding: "0.5rem 0.9rem",
                    borderRadius: "6px",
                    textDecoration: "none",
                    fontWeight: "700",
                    flex: "1",
                    textAlign: "center",
                    boxShadow: "0 0 8px rgba(255,0,0,0.3)",
                  }}
                >
                  🏆 View Bracket
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
